import type { PlayIntentWindowKind } from '../types/playIntent.types'

import { windowEndFor } from './playIntentWindows'

/**
 * Estado inicial con el que el asistente de crear partida se abre al convertir
 * unas ganas en partida (spec R10). Viaja en `location.state` de `/sessions/new`.
 */
export interface PlayIntentPrefill {
  gameId: number
  cityCode: string
  windowStart: string
  windowEnd: string
}

export const CREATE_SESSION_PATH = '/sessions/new'

export interface PlayIntentLocationState {
  playIntent: PlayIntentPrefill
}

export function playIntentLocationState(prefill: PlayIntentPrefill): PlayIntentLocationState {
  return { playIntent: prefill }
}

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/

/** Lee y valida el prefill de `location.state`; `null` si no hay o está mal formado. */
export function readPlayIntentPrefill(state: unknown): PlayIntentPrefill | null {
  if (!state || typeof state !== 'object') return null
  const raw = (state as { playIntent?: unknown }).playIntent
  if (!raw || typeof raw !== 'object') return null
  const p = raw as Record<string, unknown>
  if (
    typeof p.gameId !== 'number' ||
    !Number.isFinite(p.gameId) ||
    typeof p.cityCode !== 'string' ||
    !p.cityCode ||
    typeof p.windowStart !== 'string' ||
    !DATE_RE.test(p.windowStart) ||
    typeof p.windowEnd !== 'string' ||
    !DATE_RE.test(p.windowEnd)
  ) {
    return null
  }
  return {
    gameId: p.gameId,
    cityCode: p.cityCode,
    windowStart: p.windowStart,
    windowEnd: p.windowEnd,
  }
}

/**
 * Prefill desde el `data` de un push `PLAY_INTENT_GROUP` (todo son strings y no
 * trae el fin de la franja: se deriva de su tipo).
 */
export function prefillFromPushData(data: Record<string, unknown>): PlayIntentPrefill | null {
  const gameId = Number(data.gameId)
  const { cityCode, windowStart, windowKind } = data
  if (
    !Number.isFinite(gameId) ||
    gameId <= 0 ||
    typeof cityCode !== 'string' ||
    !cityCode ||
    typeof windowStart !== 'string' ||
    !DATE_RE.test(windowStart) ||
    (windowKind !== 'WEEKDAYS' && windowKind !== 'WEEKEND')
  ) {
    return null
  }
  return {
    gameId,
    cityCode,
    windowStart,
    windowEnd: windowEndFor(windowKind as PlayIntentWindowKind, windowStart),
  }
}
